import React, { ChangeEvent } from 'react';
import { PromotionPlace } from '@api/graphql/types';

interface Props {
    name: string;
    value: PromotionPlace | null | undefined;
    placeholder?: string;
    hint?: string;
    onChange: (value: any, name: string) => void;
}

const PromotionPlaceSelector = (props: Props) => {
    const {value, name, hint, onChange} = props;
    return (
        <>
            <select className="form-control" value={value ? value.toString() : ''} onChange={(e: ChangeEvent<HTMLSelectElement>) => {onChange(e.currentTarget.value, name); }}>
                <option value="">---</option>
                {Object.keys(PromotionPlace).map((key: string) => <option value={PromotionPlace[key]} key={key}>{PromotionPlace[key]}</option>)}
            </select>
            {hint && <span className="form-text m-b-none">{hint}</span>}
        </>
    );
};

export default PromotionPlaceSelector;



// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/components/PromotionCategorySelector.tsx